module.exports = __webpack_public_path__ + "front/img/67.462e3b44.jpg";